/* eslint-disable */ import { attributeSelectionComponent, composedOfComponent, genericDimensionComponent, memoEval, priceComponent, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { Inseam, Size } from '../model/index.js';
export const shortsComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withAlias('Shorts').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachComponent.withComponent(composedOfComponent, '$parts', true).withAlias('Shorts').attach(memoEval((self)=>self.$parts.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(priceComponent, 'default', true).withAlias('Shorts').attach(memoEval((self)=>[
            self.$price
        ], ($price)=>({
            currency: 'USD',
            price: $price
        }))),
    attachComponent.withComponent(genericDimensionComponent, 'inseam', true).withAlias('Shorts').attach(memoEval((self)=>[
            self.inseam
        ], (inseam)=>({
            min: -0.5,
            max: 0.5,
            decimalPlaces: 1,
            unit: '"',
            value: inseam
        })), (state)=>{
        Inseam.assert(state.value);
        return {
            inseam: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'size', true).withAlias('Shorts').attach(memoEval((self)=>[
            self.size
        ], (size)=>({
            options: [
                {
                    label: 'XS',
                    value: 'xs'
                },
                {
                    label: 'S',
                    value: 's'
                },
                {
                    label: 'M',
                    value: 'm'
                },
                {
                    label: 'L',
                    value: 'l'
                },
                {
                    label: 'XL',
                    value: 'xl'
                },
                {
                    label: '2XL',
                    value: '2xl'
                },
                {
                    label: '3XL',
                    value: '3xl'
                }
            ],
            value: size
        })), (state)=>{
        Size.assert(state.value);
        return {
            size: state.value
        };
    })
];

//# sourceMappingURL=shorts.js.map